import { ALERT_TYPES, PERIOD_ACCESS_TYPE_NAMES } from './constants';

export const onAuthListRowPrepared = (e, theme) => {
    if (e.rowType === 'data') {
        const authTypes = e.data?.authTypes || [];
        const hasBanned = authTypes.some((auth) => auth.name === ALERT_TYPES.BANNED);
        if (hasBanned) {
            e.rowElement.style.color = theme.palette.error.main;
        }
    } else if (e.rowType === 'detail') {
        const cells = Array.from(e.rowElement.querySelectorAll('td'));
        cells.forEach((cell) => {
            cell.style.backgroundColor = 'var(--color-light-grey)';
        });
    }
};

export const onChangeLogRowPrepared = (e, theme) => {
    if (e.rowType === 'data') {
        const newData = e.data?.data?.newData || [];
        const oldData = e.data?.data?.oldData || [];

        const containsBanned = [...newData, ...oldData].some((entry) => entry?.authType?.name === ALERT_TYPES.BANNED);

        if (containsBanned) {
            e.rowElement.style.color = theme.palette.error.main;
        }
    }
};

export const generateAlertText = (authTypes) => {
    return authTypes
        .map((auth) => {
            const accessType = auth.limitedPeriodAccess?.accessType || '';
            const displayPeriod = PERIOD_ACCESS_TYPE_NAMES[accessType] || accessType.replaceAll('_', ' ');
            return `${auth.name} - ${displayPeriod}`;
        })
        .join(' \n');
};
